export const DRAFT_ACTIONS = {
  ADD_TO_WATCH_LIST: "addToWatchList",
  CHOOSE_SPOT: "chooseSpot",
  REMOVE_FROM_WATCH_LIST: "removeFromWatchList",
  REORDER_WATCH_LIST: "reorderWatchList",
  SELECT_PLAYER_ID: "selectPlayerId",
  SELECT_TEAM_ID: "selectTeamId",
  SELECT_TAB: "selectTab",
  SET_INFO: "setInfo",
  SET_SPOTS: "setSpots",
  SET_WATCH_LIST: "setWatchList",
};

export const draftInitialState = {
  info: {
    hasStarted: false,
    hasEnded: false,
    isPaused: false,
    isChoosingSpots: false,
    hasFirstPickBeenMade: false,
    hasLastPickBeenMade: false,
    pickNumOnClock: null,
    teamIdOnClock: null,
    teamIdUpNext: null,
    timeIsRunningOut: false,
  },
  selectedPlayerId: null,
  selectedTab: 0,
  selectedTeamId: null,
  spots: [],
  watchList: [],
};

export function draftReducer(state, action) {
  if (action.type !== DRAFT_ACTIONS.SET_INFO)
    console.log(`draftReducer.${action.type} called`);
  switch (action.type) {
    case DRAFT_ACTIONS.ADD_TO_WATCH_LIST:
      state.watchList.push(action.payload);
      return;
    case DRAFT_ACTIONS.CHOOSE_SPOT:
      const { spotNum, teamId } = action.payload;
      // make sure spots is the proper length
      while (state.spots.length < spotNum) {
        state.spots.push(null);
      }
      state.spots[spotNum - 1] = teamId;
      return;
    case DRAFT_ACTIONS.REMOVE_FROM_WATCH_LIST:
      state.watchList = state.watchList.filter(
        (playerId) => playerId !== action.payload
      );
      return;
    case DRAFT_ACTIONS.REORDER_WATCH_LIST:
      state.watchList = action.payload;
      return;
    case DRAFT_ACTIONS.SELECT_PLAYER_ID:
      state.selectedPlayerId = action.payload;
      return;
    case DRAFT_ACTIONS.SELECT_TAB:
      state.selectedTab = action.payload;
      return;
    case DRAFT_ACTIONS.SELECT_TEAM_ID:
      state.selectedTeamId = action.payload;
      return;
    case DRAFT_ACTIONS.SET_INFO:
      const { propName, value } = action.payload;
      console.log(`setInfo - ${propName} = ${value}`);
      state.info[propName] = value;
      return;
    case DRAFT_ACTIONS.SET_SPOTS:
      const spotsAsString = action.payload;
      if (spotsAsString) state.spots = spotsAsString.split(",");
      return;
    case DRAFT_ACTIONS.SET_WATCH_LIST:
      const playerIdsString = action.payload;
      if (playerIdsString) state.watchList = playerIdsString.split(",");
      return;
    default:
      throw new Error(`unknown action.type: ${action.type}`);
  }
}
